import { render, staticRenderFns } from "./Interact.vue?vue&type=template&id=db0f36fe"
import script from "./Interact.vue?vue&type=script&lang=js"
export * from "./Interact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports